<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer005">
<p class="Ahead"><span class="com-rorohiko-pagestaker-style">xiii</span></p>
<p class="_toc" id="_idParaDest-3">Contents<a id="_idTextAnchor000"></a></p>
<p class="toc-end-matter ParaOverride-1"><a href="#/Acks#_idTextAnchor001"><span class="ital">Acknowledgments</span></a> </p>
<p class="toc-end-matter ParaOverride-2"><a href="#/SM#_idTextAnchor002"><span class="ital">Introduction</span></a> </p>
<p class="toc-chapters ParaOverride-1"><a href="#/SM1#_idTextAnchor003"><span class="semi">Chapter 1</span></a><span class="semi">:</span> To Do the Work  </p>
<p class="toc-chapters ParaOverride-3"><a href="#/SM2#_idTextAnchor004"><span class="semi">Chapter 2</span></a><span class="semi">:</span> That’s Why It’s Called  “Practicing” Witchcraft  </p>
<p class="toc-chapters ParaOverride-3"><a href="#/SM3#_idTextAnchor005"><span class="semi">Chapter 3</span></a><span class="semi">:</span> Tools and Definitions  </p>
<p class="toc-chapters ParaOverride-3"><a href="#/SM4#_idTextAnchor006"><span class="semi">Chapter 4</span></a><span class="semi">:</span> Natural Born  </p>
<p class="toc-chapters ParaOverride-3"><a href="#/SM5#_idTextAnchor007"><span class="semi">Chapter 5</span></a><span class="semi">:</span> Preparation Techniques  </p>
<p class="toc-chapters ParaOverride-3"><a href="#/SM6#_idTextAnchor008"><span class="semi">Chapter 6</span></a><span class="semi">:</span> Grounding  </p>
<p class="toc-chapters ParaOverride-3"><a href="#/SM7#_idTextAnchor009"><span class="semi">Chapter 7</span></a><span class="semi">:</span> Energy and Execution  </p>
<p class="toc-chapters ParaOverride-3"><a href="#/SM8#_idTextAnchor010"><span class="semi">Chapter 8</span></a><span class="semi">:</span> Protection and Pushback  </p>
<p class="toc-chapters ParaOverride-3"><a href="#/SM9#_idTextAnchor011"><span class="semi">Chapter 9</span></a><span class="semi">:</span> Living as a Witch  </p>
<p class="toc-chapters ParaOverride-3"><a href="#/SM10#_idTextAnchor012"><span class="semi">Chapter 10</span></a><span class="semi">:</span> Some Simple Workings  </p>
<p class="toc-end-matter ParaOverride-1"><a href="#/SM11#_idTextAnchor013"><span class="ital">Conclusion</span></a><span class="ital">: A Permission Slip You Don’t Need  </span></p>
<p class="toc-end-matter ParaOverride-3"><a href="#/SM12#_idTextAnchor014"><span class="ital">Bibliography</span></a> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?668c8aea